﻿window.HcProductCustomizer = window.HcProductCustomizer || {};

window.HcProductCustomizer.init = (section, productForm, i18n = {}) => {
  if (!section || !productForm) return;

    const customizer = section.querySelector('[data-hc-customizer]');

    if (customizer && productForm && section.dataset.customizerReady !== 'true') {
      section.dataset.customizerReady = 'true';

      const customizerCanvas = customizer.querySelector('[data-hc-customizer-canvas]');
      const customizerControls = customizer.querySelector('[data-hc-customizer-controls]');
      const customizerLayers = customizer.querySelector('[data-hc-customizer-layers]');
      const customizerModal = customizer.querySelector('[data-hc-customizer-modal]');
      const customizerDialog = customizer.querySelector('.hc-customizer__dialog');
      const customizerOpenButton = customizer.querySelector('[data-hc-customizer-open]');
      const customizerCloseButtons = customizer.querySelectorAll('[data-hc-customizer-close]');
      const customizerConfigScript = customizer.querySelector('[data-hc-customizer-config]');
      let customizerTemplateId = customizer.dataset.templateId || 'customize-v1';
      const customizerSelections = new Map();
      const customizerPendingLayerLoads = new Map();
      let customizerHiddenFields = null;
      let customizerPreviousBodyOverflow = '';
      let customizerPreviousFocus = null;
      const customizerOriginalParent = customizerModal?.parentNode || null;
      const customizerOriginalNextSibling = customizerModal?.nextSibling || null;
      const customizerInertElements = new Map();

      const setCustomizerPageInert = (enabled) => {
        if (!customizerModal) return;

        if (!enabled) {
          customizerInertElements.forEach((wasInert, element) => {
            if (wasInert) {
              element.setAttribute('inert', '');
            } else {
              element.removeAttribute('inert');
            }
          });
          customizerInertElements.clear();
          return;
        }

        Array.from(document.body.children).forEach((element) => {
          if (element === customizerModal || element.contains(customizerModal)) return;
          customizerInertElements.set(element, element.hasAttribute('inert'));
          element.setAttribute('inert', '');
        });
      };

      const shouldRenderCustomizerGroup = (group) => {
        const groupName = String(group?.name || '').toLowerCase();
        const groupLabel = String(group?.label || '').toLowerCase();

        if (!group?.options?.length) return false;
        if (groupName === 'size' || groupLabel.includes('bag size')) return false;
        if (groupLabel.includes('wallet') || groupName.includes('dropdown')) return false;

        return true;
      };

      const getOptionImageUrl = (option, key) => option?.[key]?.imageUrl || '';
      const getCustomizerImageUrl = (image) => {
        if (!image) return '';
        if (typeof image === 'string') return image;

        return image.imageUrl
          || image.url
          || image.src
          || image.previewImage?.imageUrl
          || image.previewImage?.url
          || image.preview_image?.imageUrl
          || image.preview_image?.url
          || '';
      };
      const isNoSelectionOption = (option) => {
        const value = String(option?.label || option?.name || '').trim().toLowerCase();
        return value === 'no' || value === 'none' || value === 'not selected';
      };

      const readCustomizerConfig = () => {
        if (!customizerConfigScript) return null;

        try {
          const parsedConfig = JSON.parse(customizerConfigScript.textContent || 'null');

          if (typeof parsedConfig === 'string') {
            return JSON.parse(parsedConfig);
          }

          return parsedConfig;
        } catch (error) {
          return null;
        }
      };

      const getCustomizerPreviewImage = (config) => getCustomizerImageUrl(config?.preview)
        || getCustomizerImageUrl(config?.previewImage)
        || getCustomizerImageUrl(config?.baseImage)
        || getCustomizerImageUrl(config?.canvasImage)
        || customizer.dataset.previewImage
        || '';

      const getCustomizerPreviewDimension = (config) => config?.preview?.dimension
        || config?.previewImage?.dimension
        || config?.baseImage?.dimension
        || config?.canvasImage?.dimension
        || null;

      const formatI18n = (template, values = {}) => String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => (
        values[key] !== undefined ? values[key] : match
      ));

      const renderCustomizerBaseImage = (config) => {
        if (!customizerCanvas) return;

        const previewUrl = getCustomizerPreviewImage(config);
        if (!previewUrl) return;

        const image = document.createElement('img');
        const dimension = getCustomizerPreviewDimension(config);
        image.src = previewUrl;
        image.alt = i18n.customizationPreview || '';
        image.className = 'hc-customizer__base';
        image.loading = 'lazy';
        image.setAttribute('data-hc-customizer-base', '');

        if (dimension?.width) image.width = dimension.width;
        if (dimension?.height) image.height = dimension.height;

        customizerCanvas.prepend(image);
      };

      const ensureCustomizerHiddenFields = () => {
        if (customizerHiddenFields) return customizerHiddenFields;

        customizerHiddenFields = document.createElement('div');
        customizerHiddenFields.hidden = true;
        customizerHiddenFields.setAttribute('data-hc-customizer-properties', '');
        productForm.appendChild(customizerHiddenFields);

        return customizerHiddenFields;
      };

      const syncCustomizerProperties = () => {
        const hiddenFields = ensureCustomizerHiddenFields();
        hiddenFields.replaceChildren();

        const selections = Array.from(customizerSelections.values());
        if (!selections.length) return;

        const summary = selections.map((selection) => `${selection.groupLabel}: ${selection.optionLabel}`).join(' | ');

        const payload = {
          templateId: customizerTemplateId,
          selections: selections.map((selection) => ({
            groupId: selection.groupId,
            groupName: selection.groupName,
            groupLabel: selection.groupLabel,
            optionId: selection.optionId,
            optionName: selection.optionName,
            optionLabel: selection.optionLabel
          }))
        };
        const customizeLabel = i18n.customize || '';
        const customizeSummaryLabel = i18n.customizeSummary || customizeLabel;
        const customizePrefixLabel = i18n.customizePrefix || customizeLabel;

        const properties = [
          [customizeSummaryLabel, summary],
          ['_customize_template_id', customizerTemplateId],
          ['_customize_payload', JSON.stringify(payload)]
        ];

        selections.forEach((selection) => {
          properties.push([`${customizePrefixLabel} - ${selection.groupLabel}`, selection.optionLabel]);
        });

        properties.forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${name}]`;
          input.value = value;
          hiddenFields.appendChild(input);
        });
      };

      const renderCustomizerLayers = () => {
        if (!customizerLayers) return;

        customizerLayers.replaceChildren();

        Array.from(customizerSelections.values())
          .sort((first, second) => first.layerOrder - second.layerOrder)
          .forEach((selection) => {
            if (!selection.overlayUrl) return;

            const image = document.createElement('img');
            image.src = selection.overlayUrl;
            image.alt = '';
            image.loading = 'lazy';
            image.className = 'hc-customizer__layer';
            image.dataset.customizerLayerId = selection.groupId;
            image.style.setProperty('--hc-customizer-layer', String(selection.layerOrder + 1));
            customizerLayers.appendChild(image);
          });
      };

      const updateCustomizerSelection = (group, option, layerOrder) => {
        const groupId = group.identifier || group.name;
        const optionLabel = String(option?.label || option?.name || '').trim();

        if (!option || isNoSelectionOption(option)) {
          customizerPendingLayerLoads.delete(groupId);
          customizerSelections.delete(groupId);
          renderCustomizerLayers();
          syncCustomizerProperties();
          return;
        }

        const nextSelection = {
          groupId,
          groupName: group.name || group.label || groupId,
          groupLabel: group.label || group.name || groupId,
          optionId: option.identifier || option.name || optionLabel,
          optionName: option.name || optionLabel,
          optionLabel,
          overlayUrl: getOptionImageUrl(option, 'overlayImage'),
          layerOrder
        };
        const previousSelection = customizerSelections.get(groupId);

        if (
          previousSelection?.overlayUrl
          && nextSelection.overlayUrl
          && previousSelection.overlayUrl !== nextSelection.overlayUrl
        ) {
          const loadToken = `${Date.now()}-${Math.random()}`;
          const preloadImage = new Image();
          customizerPendingLayerLoads.set(groupId, loadToken);

          const applyPreloadedSelection = () => {
            if (customizerPendingLayerLoads.get(groupId) !== loadToken) return;

            customizerPendingLayerLoads.delete(groupId);
            customizerSelections.set(groupId, nextSelection);
            renderCustomizerLayers();
            syncCustomizerProperties();
          };

          preloadImage.addEventListener('load', applyPreloadedSelection, { once: true });
          preloadImage.addEventListener('error', applyPreloadedSelection, { once: true });
          preloadImage.src = nextSelection.overlayUrl;
          return;
        }

        customizerPendingLayerLoads.delete(groupId);
        customizerSelections.set(groupId, nextSelection);
        renderCustomizerLayers();
        syncCustomizerProperties();
      };

      const renderCustomizerGroup = (group, layerOrder) => {
        const groupId = group.identifier || group.name;
        const groupElement = document.createElement('div');
        groupElement.className = 'hc-customizer__group';
        groupElement.dataset.customizerGroupId = groupId;

        const label = document.createElement('div');
        label.className = 'hc-customizer__group-label';

        const labelText = document.createElement('span');
        labelText.textContent = group.label || group.name || i18n.customize || '';

        const selectedText = document.createElement('span');
        selectedText.className = 'hc-customizer__selected';
        selectedText.textContent = i18n.optional || '';
        selectedText.dataset.customizerSelectedLabel = '';

        label.append(labelText, selectedText);

        const options = document.createElement('div');
        options.className = 'hc-customizer__options';

        const renderButton = (option, visibleIndex = 0) => {
          const button = document.createElement('button');
          const optionLabel = String(option.label || option.name || i18n.option || '').trim();
          button.type = 'button';
          button.className = 'hc-customizer__option';
          if (visibleIndex > 5) button.classList.add('is-extra-hidden');
          button.setAttribute('aria-pressed', 'false');
          button.title = optionLabel;

          const thumbnailUrl = getOptionImageUrl(option, 'thumbnailImage');
          if (thumbnailUrl) {
            const image = document.createElement('img');
            image.src = thumbnailUrl;
            image.alt = optionLabel;
            image.loading = 'lazy';
            button.appendChild(image);
          } else {
            const text = document.createElement('span');
            text.className = 'hc-customizer__option-label';
            text.textContent = optionLabel;
            button.appendChild(text);
          }

          button.addEventListener('click', () => {
            const shouldClearSelection = button.classList.contains('is-selected');

            options.querySelectorAll('.hc-customizer__option').forEach((optionButton) => {
              optionButton.classList.toggle('is-selected', !shouldClearSelection && optionButton === button);
              optionButton.setAttribute('aria-pressed', String(!shouldClearSelection && optionButton === button));
            });

            selectedText.textContent = shouldClearSelection ? i18n.optional || '' : optionLabel;
            updateCustomizerSelection(group, shouldClearSelection ? null : option, layerOrder);
          });

          return button;
        };

        const renderedOptions = group.options.filter((option) => !isNoSelectionOption(option));

        renderedOptions.forEach((option, optionIndex) => {
          options.appendChild(renderButton(option, optionIndex));
        });

        if (renderedOptions.length > 6) {
          const seeAllButton = document.createElement('button');
          seeAllButton.type = 'button';
          seeAllButton.className = 'hc-customizer__see-all';
          seeAllButton.setAttribute('aria-expanded', 'false');
          seeAllButton.innerHTML = `<span>${formatI18n(i18n.seeAllOptions, { count: renderedOptions.length })}</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>`;

          seeAllButton.addEventListener('click', () => {
            const isExpanded = groupElement.classList.toggle('is-expanded');
            seeAllButton.setAttribute('aria-expanded', String(isExpanded));
            seeAllButton.querySelector('span').textContent = isExpanded
              ? i18n.showFewerOptions || ''
              : formatI18n(i18n.seeAllOptions, { count: renderedOptions.length });
          });

          groupElement.append(label, options, seeAllButton);
          return groupElement;
        }

        groupElement.append(label, options);
        return groupElement;
      };

      const openCustomizerModal = () => {
        if (!customizerModal) return;

        customizerPreviousFocus = document.activeElement;
        customizerPreviousBodyOverflow = document.body.style.overflow;
        document.body.appendChild(customizerModal);
        customizerModal.hidden = false;
        customizerModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hc-customizer-is-open');
        document.body.style.overflow = 'hidden';
        setCustomizerPageInert(true);

        window.requestAnimationFrame(() => {
          customizerDialog?.focus({ preventScroll: true });
        });
      };

      const closeCustomizerModal = () => {
        if (!customizerModal || customizerModal.hidden) return;

        customizerModal.hidden = true;
        customizerModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('hc-customizer-is-open');
        setCustomizerPageInert(false);
        document.body.style.overflow = customizerPreviousBodyOverflow;

        if (customizerOriginalParent) {
          customizerOriginalParent.insertBefore(
            customizerModal,
            customizerOriginalNextSibling && customizerOriginalNextSibling.parentNode === customizerOriginalParent
              ? customizerOriginalNextSibling
              : null
          );
        }

        if (customizerPreviousFocus instanceof HTMLElement) {
          customizerPreviousFocus.focus({ preventScroll: true });
        }
      };

      customizerOpenButton?.addEventListener('click', openCustomizerModal);
      customizerCloseButtons.forEach((button) => button.addEventListener('click', closeCustomizerModal));
      customizerModal?.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        event.preventDefault();
        closeCustomizerModal();
      });

      const customizerConfig = readCustomizerConfig();

      if (customizerConfig?.templateId) {
        customizerTemplateId = customizerConfig.templateId;
      }

      renderCustomizerBaseImage(customizerConfig);

      const customizerGroups = Array.isArray(customizerConfig?.optionGroups)
        ? customizerConfig.optionGroups.filter(shouldRenderCustomizerGroup)
        : [];

      if (!customizerGroups.length) {
        const emptyMessage = document.createElement('p');
        emptyMessage.className = 'hc-customizer__empty';
        emptyMessage.textContent = i18n.noCustomizationOptions || '';
        customizerControls.replaceChildren(emptyMessage);
      } else {
        customizerControls.replaceChildren(...customizerGroups.map(renderCustomizerGroup));
        syncCustomizerProperties();
      }
    }

};

